import LeadSourcesDefaults from "@/components/features/settings/defaults/lead-sources/LeadSourcesDefaults";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/lead-sources")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsLeadSources)) {
    return <GlobalNotAuthorized />;
  }

  return <LeadSourcesDefaults />;
}
